module.exports = __webpack_public_path__ + "img/Rocket.2a63427.svg";